import React from 'react';

export const InfoIcon = ({ color = 'currentColor' }) => (
    <svg width="22" height="22" viewBox="0 0 256 256" aria-hidden="true" style={{ flex: '0 0 22px', marginTop: 1 }}>
        <circle cx="128" cy="128" r="96" fill="none" stroke={color} strokeWidth="14" />
        <line x1="128" y1="120" x2="128" y2="176" stroke={color} strokeWidth="16" strokeLinecap="round" />
        <circle cx="128" cy="84" r="10" fill={color} />
    </svg>
);
